<template>
    <PopupRouterView :showLeftIcon="true" label="Rack Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="rack"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="rackInput">


        <b-card header="Rack" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-code" label-cols-lg="12"  label="Code" label-for="input-code" size="sm" :model.sync="model.code" :isRequired="true" :state="validateState('code')" :errorMessage="getErrorMessage(errorMessage.code, 'code')"   :isUpdatable ="null"/>
					<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"   :isUpdatable ="null"/>
					<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Area" id="fieldset-area" size="sm" :model.sync="model.areaId" :isRequired="true" :state="validateState('areaId')" :errorMessage="getErrorMessage(errorMessage.areaId, 'areaId')"  :selected="model.area != null ? model.area.code : ''" @input="getAreas"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedArea" :reloadData="true"/>
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Customer" id="fieldset-customer" size="sm" :model.sync="model.customerId"   :selected="model.customer != null ? model.customer.code : ''" @input="getCustomers"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedCustomer" />
					<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Line" id="fieldset-line" size="sm" :model.sync="model.lineId"   :selected="model.line != null ? model.line.code : ''" @input="getLines"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedLine" />
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="fieldset-part" size="sm" :model.sync="model.partId"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" />
					<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Vendor" id="fieldset-vendor" size="sm" :model.sync="model.vendorId" :selected="model.vendor != null ? model.vendor.code : ''" @input="getVendors" @change="updateData" :isUpdatable ="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedVendor" />
				</b-col>
            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Rack from '@/models/Rack/Rack';
import RackList from '@/models/Rack/RackList';
import RackFilter from '@/filters/Rack/RackFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Area from '@/models/Area/Area';
import AreaFilter from '@/filters/Area/AreaFilter';
import Customer from '@/models/Customer/Customer';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import Line from '@/models/Line/Line';
import LineFilter from '@/filters/Line/LineFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			code: {required},
			name: {required},
			areaId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				code: { required : "Code is Required."},
				name: { required : "Name is Required."},
				areaId: { required : "Area is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterRack : null,
			currentRackPage : 1,
			rackPageSize: 10,
			sortByRack: '',
			sortDescRack: '',
			areas: [],
			areas: [],
			isAreaComboLoading: false,
			customers: [],
			customers: [],
			isCustomerComboLoading: false,
			lines: [],
			lines: [],
			isLineComboLoading: false,
			parts: [],
			parts: [],
			isPartComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isAreaComboLoading: false,
			isCustomerComboLoading: false,
			isLineComboLoading: false,
			isPartComboLoading: false,
			vendors: [],
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getRack : async function(id) {
			this.isBusy = true;
			Rack.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadRack = true;
			this.filterRack.id = this.modelId;
			Rack.downloadDataDetail(this, this.filterRack).then(result => {
				this.isDownloadRack = false;
			}).catch(error => { this.isDownloadRack = false; })
		},
		getRacks : async function(input) {
			let filter = new RackFilter();
			if (input != undefined) {
				filter.Code = input;
			}
			this.isRackComboLoading = true;
			Rack.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.racks = result.data
				}
				this.isRackComboLoading = false;
			})
			.catch(error => {});
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedArea(item) {
			if(item == undefined || item == null) {
				this.model.areaId = null;
				this.model.area = null;
			} else {
				this.model.areaId = item.id;
				this.model.area = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedVendor(item) {
			if(item == undefined || item == null) {
				this.model.vendorId = null;
				this.model.vendor = null;
			} else {
				this.model.vendorId = item.id;
				this.model.vendor = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedCustomer(item) {
			if(item == undefined || item == null) {
				this.model.customerId = null;
				this.model.customer = null;
			} else {
				this.model.customerId = item.id;
				this.model.customer = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getLines : async function(input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Line.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lines = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedLine(item) {
			if(item == undefined || item == null) {
				this.model.lineId = null;
				this.model.line = null;
			} else {
				this.model.lineId = item.id;
				this.model.line = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.rackInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			let customerId = this.model.customerId;
			let lineId = this.model.lineId;
			let partId = this.model.partId;

			if (this.model.customerId == undefined) {
				this.$set(this.model, 'customerId', '');
			}else{
				delete this.model.customerId;
				this.$set(this.model, 'customerId', customerId);
			}

			if (this.model.lineId == undefined) {
				this.$set(this.model, 'lineId', '');
			}else{
				delete this.model.lineId;
				this.$set(this.model, 'lineId', lineId);
			}

			if (this.model.partId == undefined) {
				this.$set(this.model, 'partId', '');
			}else{
				delete this.model.partId;
				this.$set(this.model, 'partId', partId);
			}

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						Rack.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'rackindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						Rack.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'rackindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData(state) {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					Rack.updateData(this, model, id)
					.catch((error) => {
						this.getRack(id);
					});
				}
			});
		},
		onHidden() {
			this.getRacks();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterRack = new RackFilter();
		//this.getAreas();
		//this.getCustomers();
		//this.getLines();
		//this.getParts();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getRack(id);
			} else {
				this.modelId = id;
				this.getRack(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
